export const FEATURE_SUGGESTIONS = {
    TITLE: 'title',
    DELETE_COMPLETED_TASKS: 'deleteTasks',
};
